import { render } from "./RcpBasicDetails.vue?vue&type=template&id=836f5938&scoped=true"
import script from "./RcpBasicDetails.vue?vue&type=script&lang=js"
export * from "./RcpBasicDetails.vue?vue&type=script&lang=js"

import "./RcpBasicDetails.vue?vue&type=style&index=0&id=836f5938&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836f5938"]])

export default __exports__